// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '13.0.0-beta.20251209.1515';
